module.exports = __webpack_public_path__ + "static/img/6.a601da8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/preview/pengu/6.png
// module id = uXyK
// module chunks = 35